import React from 'react';
import { cn } from '../../utils/cn';

export interface FormFieldProps {
  label?: string;
  required?: boolean;
  error?: string;
  helperText?: string;
  children: React.ReactNode;
  className?: string;
  labelClassName?: string;
  errorClassName?: string;
  helperClassName?: string;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  required = false,
  error,
  helperText,
  children,
  className,
  labelClassName,
  errorClassName,
  helperClassName,
}) => {
  return (
    <div className={cn('space-y-2', className)}>
      {label && (
        <label className={cn(
          'block text-sm font-medium text-gray-700',
          labelClassName
        )}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      {children}
      
      {error && (
        <p className={cn(
          'text-sm text-red-600',
          errorClassName
        )}>
          {error}
        </p>
      )}
      
      {helperText && !error && (
        <p className={cn(
          'text-sm text-gray-500',
          helperClassName
        )}>
          {helperText}
        </p>
      )}
    </div>
  );
};

export default FormField; 